import { ReactNode } from "react";

import { ErrorBoundary } from "components/errorBoundary";

import { useControlHealthFilters } from "./filters/ControlHealthFiltersProvider";

export function ControlHealthWidgetsErrorBoundary({
    children,
}: {
    children: ReactNode;
}) {
    const { filters } = useControlHealthFilters();

    return (
        <ErrorBoundary routeKey={JSON.stringify(filters)} inline>
            {children}
        </ErrorBoundary>
    );
}
